import React from "react";

export const AlamatIsi = (props) => {
  const { jalan, kodepos } = props.data;

  return (
    <div className="alamat_title">
      <div className="description">
        <p>
        <b>{jalan}</b>
        </p>
        <p> Kode Pos: {kodepos}</p>
      </div>
    </div>
  );
};